var exports = {
  "k": "x127c5a35--c20e59--container",
};

module.exports = exports;
